// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1h9Lp","name":"Header_name__dq-J0","birthday":"Header_birthday__3N5Es","skeleton":"Header_skeleton__2yMxj"};